import {UniversalLoginInstance} from 'app/modules/auth/types/universalLogin'
import clsx from 'clsx'
import {Modal} from 'react-bootstrap'

import {systemMode, useThemeMode} from '_metronic/partials'

type Props = {
  show: boolean
  instances: UniversalLoginInstance[]
  loading?: boolean
  onSelect: (instance: UniversalLoginInstance) => void
  onClose: () => void
}

export function UniversalLoginSchoolPicker({
  show,
  instances,
  loading = false,
  onSelect,
  onClose,
}: Props) {
  // The modal renders in a portal on the theme-colored .modal-content surface, so the
  // white "glass" styling is tied to the active theme, not the domain.
  const {mode} = useThemeMode()
  const isSpecialDomain = (mode === 'system' ? systemMode : mode) === 'dark'

  return (
    <Modal show={show} onHide={onClose} centered backdrop='static' keyboard={!loading}>
      <Modal.Header
        closeButton={!loading}
        className={clsx(isSpecialDomain && 'border-0 bg-transparent')}
      >
        <Modal.Title className={clsx(isSpecialDomain && 'text-white')}>
          Select your school
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={clsx(isSpecialDomain && 'pt-0')}>
        <p className={clsx('mb-6', isSpecialDomain ? 'text-white-50' : 'text-gray-600')}>
          Your account is linked to multiple schools. Choose one to continue.
        </p>
        <div className='d-flex flex-column gap-3'>
          {instances.map((instance) => {
            const logo = instance.logos?.small || instance.logos?.big
            return (
              <button
                key={instance.applicationId}
                type='button'
                disabled={loading}
                onClick={() => onSelect(instance)}
                className={clsx(
                  'btn w-100 text-start d-flex align-items-center gap-3 p-4',
                  isSpecialDomain
                    ? 'text-white border border-white border-opacity-15'
                    : 'btn-light-primary border'
                )}
                style={
                  isSpecialDomain
                    ? {background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12}
                    : {borderRadius: 12}
                }
              >
                {logo ? (
                  <img
                    src={logo}
                    alt=''
                    style={{width: 40, height: 40, objectFit: 'contain', borderRadius: 8}}
                  />
                ) : (
                  <div
                    className='d-flex align-items-center justify-content-center fw-bold'
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 8,
                      background: isSpecialDomain ? 'rgba(255,255,255,0.12)' : '#eef2ff',
                      color: isSpecialDomain ? '#fff' : '#3b82f6',
                    }}
                  >
                    {instance.schoolName?.charAt(0) ?? 'S'}
                  </div>
                )}
                <div>
                  <div className='fw-bold'>{instance.schoolName}</div>
                  <div
                    className={clsx('fs-7', isSpecialDomain ? 'text-white-50' : 'text-gray-500')}
                  >
                    {instance.portalUrl.replace(/^https?:\/\//, '')}
                  </div>
                </div>
              </button>
            )
          })}
        </div>
      </Modal.Body>
    </Modal>
  )
}
